// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2M4rU","location":"Header_location__5dUEa"};